import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import AdminRoute from './components/AdminRoute';

// Pages
import Login from './pages/Login';
import Home from './pages/Home';
import Calculadora from './pages/Calculadora';
import GiftCards from './pages/GiftCards';
import GiftcardRequests from './pages/GiftcardRequests';
import GiftcardCoupons from './pages/GiftcardCoupons';
import CodigosConvenio from './pages/CodigosConvenio';
import ProductOrders from './pages/ProductOrders';
import StoreProducts from './pages/StoreProducts';
import PremiumClub from './pages/PremiumClub';
import DeudasClub from './pages/DeudasClub';
import BarberApplications from './pages/BarberApplications';
import HomeServiceRequests from './pages/HomeServiceRequests';

const queryClient = new QueryClient();

const InternalApp = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Home />} />
          <Route path="calculadora" element={<Calculadora />} />
          <Route path="gift-cards" element={<GiftCards />} />
          <Route path="solicitudes-a-domicilio" element={<HomeServiceRequests />} />
          <Route path="solicitudes-a-domicilio/:id" element={<HomeServiceRequests />} />
          <Route path="giftcard-requests" element={<GiftcardRequests />} />
          <Route path="giftcard-coupons" element={<GiftcardCoupons />} />
          <Route path="product-orders" element={<ProductOrders />} />
          <Route path="store-products" element={<AdminRoute><StoreProducts /></AdminRoute>} />
          <Route path="premium-club" element={<PremiumClub />} />
          <Route path="codigos-convenio" element={<CodigosConvenio />} />
          <Route path="deudas-club" element={<AdminRoute><DeudasClub /></AdminRoute>} />
          <Route path="barber-applications" element={<AdminRoute><BarberApplications /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  </QueryClientProvider>
);

function App() {
  return (
    <Router>
      <InternalApp />
    </Router>
  );
}

export default App;
